<div class="vtr-material-button">
	<div class="vtr-material-button-box">
		<button
			[ngStyle]="{'overflow': overFlow, 'text-overflow': textOverFlow }"
			mat-customize-button
			[color]="color"
			[disabled]="isDisabled"
			type={{buttonType}}
			[id]="linkId"
			[ngClass]="buttonClasses"
			(click)="onButtonClick($event)"
			[matTooltip]="tooltip ? tooltipText : ''"
			matTooltipClass="vtr-system-tooltip">
			{{ label }}
		</button>
	</div>
</div>
